// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Loan post dated check batch payment'"></sub-header>

<div>

  <div class="actions">
    <div class="filters">
      <div class="labelled-field labelled-field--long">
        <label for="pdc-status-filter" class="add-on">Status</label>
        <multiselect ng-model="\$ctrl.filter.status"
                     id="pdc-status-filter"
                     select-all-option="true"
                     items="\$ctrl.availableStatuses"
        ></multiselect>
      </div>

      <!-- Check registration date -->
      <date-range-picker model="\$ctrl.filter.dateRange"></date-range-picker>

      <!-- Actions -->
      <button ng-click="\$ctrl.onFilterBtnClicked()" class="btn btn-primary btn--filter" type="button">
        Filter
      </button>
    </div>

    <form name="\$ctrl.paymentForm" class="filters">
      <div class="labelled-field labelled-field--short" ng-if="!\$ctrl.autoOfficialReceiptEnabled">
        <label for="pdc-official-receipt">Use Multiple Invoice</label>
        <select boolean-options
          ng-model="\$ctrl.isMultipleOr"
          ng-required="true">
        </select>
      </div>
      <div class="labelled-field labelled-field--short" ng-if="!\$ctrl.isMultipleOr || !\$ctrl.autoOfficialReceiptEnabled">
        <label for="pdc-official-receipt">Invoice</label>
        <input id="pdc-official-receipt"
               type="text"
               class="actions__input"
               ng-model="\$ctrl.officialReceipt"
               ng-disabled="!\$ctrl.isAnyPdcSelected() || \$ctrl.autoOfficialReceiptEnabled"
               ng-required="\$ctrl.isAnyPdcSelected()">
      </div>

      <button class="btn btn-success btn--filter"
              ng-if="\$ctrl.isMultipleOr || \$ctrl.autoOfficialReceiptEnabled"
              ng-disabled="!\$ctrl.isAnyPdcSelected() || \$ctrl.paymentForm.\$invalid"
              ng-click="\$ctrl.showBatchPDCPaymentModal()">Simulate
      </button>
      <button class="btn btn-success btn--filter"
              type="submit"
              command-access="PayLoanByPDCBatch"
              ng-disabled="!\$ctrl.isAnyPdcSelected() || \$ctrl.paymentForm.\$invalid"
              ng-click="\$ctrl.onPostClicked()">Post
      </button>
    </form>
  </div>
  <div class="alert alert--danger" ng-if="!\$ctrl.officialReceipt && \$ctrl.autoOfficialReceiptEnabled">
    User has no available automated invoice!
  </div>

  <div ng-if="\$ctrl.filter">
    <selectable-list on-api-ready="\$ctrl.onSelectableListApiReady(tableAPI)"
                     columns="\$ctrl.columns"
                     selectable-column-label="Select"
                     records-per-page="20"
                     get-records-page="\$ctrl.getPdcOnCurrentPage(pageSettings)"
                     on-change="\$ctrl.onPdcSelected(checkedRecords)">
    </selectable-list>
  </div>

  <div class="payment-result" ng-if="!\$ctrl.isEmpty(\$ctrl.invalidPaymentData) || !\$ctrl.isEmpty(\$ctrl.validPaymentData)">
    <h2 class="section-header">Payment result</h2>

    <div ng-if="!\$ctrl.isEmpty(\$ctrl.invalidPaymentData)">
      <div class="alert alert--danger payment-result__table-header">
        Unsuccessful payments:
      </div>
      <dynamic-list
        columns="\$ctrl.invalidPaymentColumns"
        data="\$ctrl.invalidPaymentData"
        list-type="'ERROR'">
      </dynamic-list>
    </div>

    <div ng-if="!\$ctrl.isEmpty(\$ctrl.validPaymentData)">
      <div class="alert payment-result__table-header">
        Successful payments:
      </div>
      <dynamic-list
        columns="\$ctrl.validPaymentColumns"
        data="\$ctrl.validPaymentData">
      </dynamic-list>
    </div>
  </div>
</div>
</section>

<modal on-api-ready="\$ctrl.onBatchPDCPaymentModalApiReady">
  <modal-header>
    <h2>Simulate Batch PDC Payment</h2>
  </modal-header>
  <modal-body>
    <ng-form name="\$ctrl.modalForm">
      <table class="table">
        <tr>
          <th>No.</th>
          <th ng-repeat="column in \$ctrl.columns">{{ column.label }}</th>
          <th>Invoice</th>
        </tr>
        <tr ng-repeat="record in \$ctrl.modalSelectedPdcs" ng-if="\$ctrl.modalSelectedPdcs">
          <td>{{ \$index + 1 }}</td>
          <td ng-repeat="col in \$ctrl.columns" ng-class="col.align">{{ record[col.field] }}</td>
          <td>
            <input type="text"
                   ng-model="record.officialReceipt"
                   ng-required="true"
                   ng-disabled="\$ctrl.autoOfficialReceiptEnabled">
          </td>
        </tr>
      </table>
    </ng-form>
  </modal-body>
  <modal-footer>
    <button type="button" ng-click="\$ctrl.cancelBatchPDCModal()" class="btn">Cancel</button>
    <button type="submit" ng-click="\$ctrl.confirmBatchPDCModal()" ng-disabled="!\$ctrl.modalForm.\$valid" class="btn btn-success">
      Confirm
    </button>
  </modal-footer>
</modal>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/inventory/batch-pdc-payment/batch-pdc-payment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;